import { createSlice } from '@reduxjs/toolkit'

export const menuSlice = createSlice({
    name: 'menuslice',
    initialState: {
      value: []
    },
    reducers: {
      menuChange: (state, action) => {
        state.value = action.payload.value
      }
    }
  })
  // 每个 case reducer 函数会生成对应的 Action creators
  export const { menuChange } = menuSlice.actions
  
  export default menuSlice.reducer